$(document).ready(function () {
    if ($('#my_dossier_requests_table').length) {
        let finalizeButtons = document.querySelectorAll('.dismiss-dossier-request');

        finalizeButtons.forEach(finalizeButton => {
            finalizeButton.addEventListener('click', function (e) {
                let finalizeRoute = this.getAttribute('data-finalize-route');

                confirm("Weet u zeker dat u deze aanvraag wilt afhandelen? <br><br> Dit kan niet worden teruggedraait en deze aanvraag verdwijnt hierna uit uw dashboard.", () => {
                    let button = this;

                    $.ajax({
                        url: finalizeRoute,
                        type: 'POST',
                        success: function (response) {
                            $(button).closest('tr').fadeOut(500, function () {
                                $(this).remove();
                            });
                        }
                    });
                });
            });
        });
    }
});
